import React from 'react';
import { Checkbox, MenuItem, Select } from '@mui/material';

import { SORT, COLORS } from '$gbusiness/enums';
import CellModel from '$gbusiness/models/cell';
import { defaultStyles } from '$gbusiness/models/table';
import { Delete } from '@mui/icons-material';


export const FILE_PREIVEW_STYLE = {
  ...defaultStyles,
  color: COLORS.LIGHT,
  fontSize: '1em',
  minWidth: 600,
  maxWidth: 900,
  cellPadding: ` 8px 4px`,
  isStripped: false,
};

const FILE_PREVIEW_TABLE = (onChangeField, onDeleteRow, folderOptions: Array<any> = []): Array<CellModel> => [
  {
    label: 'SCREEN.FILES.COLS.NAME',
    value: 'name',
    component: (row, action, index) => (
      <input
        className="name"
        onChange={e => onChangeField({ name: e.target.value, index })}
        value={row.name}
      />
    ),
    alwaysShow: true,
    width: 200,
  },
  {
    label: 'SCREEN.FILES.COLS.DESCRIPTION',
    value: 'description',
    component: (row, action, index) => (
      <input
        className="description"
        onChange={e => onChangeField({ description: e.target.value, index })}
        value={row.description}
      />
    ),
    alwaysShow: true,
    width: 300,
  },
  {
    label: 'SCREEN.FILES.COLS.FILE_NAME',
    value: 'fileName',
    component: row => <>{row.file ? row.fileName : row.youtubeLink}</>,
    sortable: SORT.ASC,
    alwaysShow: true,
    width: 220,
  },
  // {
  //   label: 'SCREEN.FILES.COLS.FILE_TYPE',
  //   value: 'fileType',
  //   sortable: SORT.ASC,
  //   alwaysShow: true,
  //   width: 140,
  // },
  {
    label: 'SCREEN.FILES.COLS.FILE_SIZE',
    value: 'fileSize',
    sortable: SORT.ASC,
    alwaysShow: true,
    width: 120,
  },
  {
    label: 'SCREEN.FILES.COLS.FOLDER',
    value: 'folderId',
    component: (row, action, index) => (
      <Select
        className="doctype"
        variant="standard"
        value={row.folderId || 0}
        onChange={(e) => onChangeField({ folderId: e.target.value, index })}>
        <MenuItem value={0}>All files (top level)</MenuItem>
        {folderOptions.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.labelText}
          </MenuItem>
        ))}
      </Select>
    ),
    alwaysShow: true,
    align: 'center',
    width: 120,
  },
  {
    label: 'SCREEN.FILES.COLS.PROTECTED',
    value: 'isProtected',
    component: (row, action, index) => (
      <Checkbox
        checked={!!row.isProtected}
        onChange={(e) =>
          onChangeField({
            isProtected: e.target.checked,
            // Clear passcode when unchecking so we don't accidentally submit one.
            ...(e.target.checked ? {} : { passcode: '' }),
            index,
          })
        }
      />
    ),
    alwaysShow: true,
    align: 'center',
    width: 90,
  },
  {
    label: 'SCREEN.FILES.COLS.PASSCODE',
    value: 'passcode',
    component: (row, action, index) =>
      row.isProtected ? (
        <input
          type="text"
          className="passcode"
          autoComplete="off"
          value={row.passcode || ''}
          onChange={(e) => onChangeField({ passcode: e.target.value, index })}
        />
      ) : null,
    alwaysShow: true,
    width: 140,
  },
  {
    label: '',
    value: '',
    component: (row, action, index) => <Delete onClick={() => onDeleteRow(index)} />,
    width: 60,
  },
];

export default FILE_PREVIEW_TABLE;
